import ApiService from '../common/api.service';

import {
  FETCH_IMAGE,
  FETCH_DESEMPENIOS,
  ADD_DESEMPENIO,
  REMOVE_DESEMPENIO,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_IMAGE](context, image, originalContext) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.queryBlob(`rh/rh_evidence_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          resolve(buffer);
        })
        .catch(() => {
        });
    });
  },
  [FETCH_DESEMPENIOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/desempenios', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [ADD_DESEMPENIO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/agregar_desempenio', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_DESEMPENIO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/eliminar_desempenio', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
